import { MenuCategory } from '../types';

export const menuData: MenuCategory[] = [
  {
    id: 'breakfast',
    name: {
      en: 'Breakfast',
      de: 'Frühstück',
      sv: 'Frukost'
    },
    items: [
      {
        id: 'breakfast-box',
        name: {
          en: 'A piece of pastry, jam, cream cheese, margarine, orange juice, a hot drink of your choice',
          de: 'Ein Stück Gebäck, Marmelade, Frischkäse, Margarine, Orangensaft, ein Heißgetränk nach Wahl',
          sv: 'Frukostbox med bröd, sylt, färskost, margarin, apelsinjuice och kaffe, te eller choklad'
        },
        price: { eur: 9.20, sek: 94 },
        allergens: ['A', 'G']
      }
    ]
  },
  {
    id: 'hot-dishes',
    name: {
      en: 'Hot dishes and sandwiches',
      de: 'Warme Speisen und Sandwiches',
      sv: 'Varmrätter och smörgåsar'
    },
    items: [
      {
        id: 'meatballs',
        name: {
          en: 'Meatballs with lingonberries and mashed potatoes',
          de: 'Köttbullar mit Preiselbeeren und Kartoffelpüree',
          sv: 'Köttbullar med lingon och potatismos'
        },
        price: { eur: 7.70, sek: 79 },
        allergens: ['G', 'F'],
        tags: ['organic']
      },
      {
        id: 'currywurst',
        name: {
          en: 'Berlin curry sausage with roll',
          de: 'Berliner Currywurst mit Brötchen',
          sv: 'Berlin currywurst med bröd'
        },
        price: { eur: 9.70, sek: 99 },
        allergens: ['A', 'J'],
        additives: ['1', '2', '7', '11']
      },
      {
        id: 'pasta',
        name: {
          en: 'Pasta with tomato sauce and parsley pesto',
          de: 'Nudeln mit Tomatensauce und Petersilienpesto',
          sv: 'Pasta med tomatsås och persiljepesto'
        },
        price: { eur: 8.20, sek: 85 },
        allergens: ['G'],
        tags: ['organic']
      },
      {
        id: 'shrimp-sandwich',
        name: {
          en: 'Shrimp sandwich with egg and dill mayonnaise',
          de: 'Garnelen-Sandwich mit Ei und Dill-Mayonnaise',
          sv: 'Räksmörgås med ägg och dillmajonäs'
        },
        price: { eur: 13.70, sek: 139 },
        allergens: ['A', 'B', 'C', 'G', 'J']
      },
      {
        id: 'pancakes',
        name: {
          en: 'Pancakes',
          de: 'Pfannkuchen',
          sv: 'Pannkakor'
        },
        price: { eur: 5.20, sek: 55 },
        allergens: ['A', 'C', 'G'],
        tags: ['organic']
      }
    ]
  },
  {
    id: 'snacks',
    name: {
      en: 'Snacks',
      de: 'Snacks',
      sv: 'Snacks'
    },
    items: [
      {
        id: 'tyrolean-sausage',
        name: {
          en: 'Tyrolean sausages 100 g',
          de: 'Tiroler Kaminwurzen 100 g',
          sv: 'Rökt korv från Tyrolen 100 g'
        },
        price: { eur: 4.70, sek: 49 },
        allergens: ['J'],
        additives: ['1', '2', '3']
      },
      {
        id: 'cheese-platter',
        name: {
          en: 'Cheese platter 210 g',
          de: 'Käseplatte 210 g',
          sv: 'Osttallrik 210 g'
        },
        price: { eur: 11.70, sek: 119 },
        allergens: ['A', 'G', 'J']
      },
      {
        id: 'pringles',
        name: {
          en: 'Pringles Chips Original 40 g',
          de: 'Pringles Chips Original 40 g',
          sv: 'Pringles chips original 40 g'
        },
        price: { eur: 3.70, sek: 39 },
        allergens: ['A'],
        additives: ['1']
      },
      {
        id: 'cashews',
        name: {
          en: 'Cashew nuts 40 g',
          de: 'Cashew Nüsse 40 g',
          sv: 'Cashewnötter 40 g'
        },
        price: { eur: 3.70, sek: 39 }
      },
      {
        id: 'manner-waffles',
        name: {
          en: 'Manner waffles 75 g',
          de: 'Manner Waffeln 75 g',
          sv: 'Mannervåfflor 75 g'
        },
        price: { eur: 2.70, sek: 29 },
        allergens: ['A', 'E', 'F'],
        tags: ['vegan']
      },
      {
        id: 'mms',
        name: {
          en: 'M&Ms choco 45 g',
          de: 'M&Ms Choco 45 g',
          sv: 'M&Ms choklad 45 g'
        },
        price: { eur: 2.70, sek: 29 },
        allergens: ['E', 'F', 'G', 'H'],
        additives: ['1']
      }
    ]
  },
  {
    id: 'hot-drinks',
    name: {
      en: 'Hot drinks',
      de: 'Heißgetränke',
      sv: 'Varma drycker'
    },
    items: [
      {
        id: 'coffee',
        name: {
          en: 'Coffee',
          de: 'Kaffee',
          sv: 'Kaffe'
        },
        price: { eur: 2.70, sek: 29 },
        additives: ['9']
      },
      {
        id: 'hot-chocolate',
        name: {
          en: 'Hot chocolate',
          de: 'Heiße Schokolade',
          sv: 'Varm choklad'
        },
        price: { eur: 2.70, sek: 29 },
        allergens: ['G']
      },
      {
        id: 'tea',
        name: {
          en: 'Tea – various flavours',
          de: 'Tee – verschiedene Sorten',
          sv: 'Te – olika sorter'
        },
        price: { eur: 2.70, sek: 29 }
      }
    ]
  },
  {
    id: 'non-alcoholic',
    name: {
      en: 'Non-alcoholic drinks',
      de: 'Alkoholfreie Getränke',
      sv: 'Alkoholfria drycker'
    },
    items: [
      {
        id: 'fritz-kola',
        name: {
          en: 'Fritz Kola/Kola sugarfree 33 cl',
          de: 'Fritz Kola/Kola zuckerfrei 33 cl',
          sv: 'Fritz Kola/Kola sockerfri 33 cl'
        },
        price: { eur: 3.70, sek: 39 },
        additives: ['1', '2', '9', '11']
      },
      {
        id: 'fritz-mischmasch',
        name: {
          en: 'Fritz Mischmasch (cola and orangeade) 33 cl',
          de: 'Fritz Mischmasch 33 cl',
          sv: 'Fritz Mischmasch (cola och apelsinläsk) 33 cl'
        },
        price: { eur: 3.70, sek: 39 },
        additives: ['1', '2', '9', '11']
      },
      {
        id: 'fritz-apple',
        name: {
          en: 'Fritz apple spritzer 33 cl',
          de: 'Fritz Apfelschorle 33 cl',
          sv: 'Fritz Äppel spritzer 33 cl'
        },
        price: { eur: 3.70, sek: 39 },
        tags: ['organic']
      },
      {
        id: 'fritz-lemon',
        name: {
          en: 'Fritz lemonade 33 cl',
          de: 'Fritz Limo Zitrone 33 cl',
          sv: 'Fritz Citron 33 cl'
        },
        price: { eur: 3.70, sek: 39 },
        additives: ['3', '11']
      },
      {
        id: 'orange-juice',
        name: {
          en: 'Orange juice 20 cl',
          de: 'Orangensaft 20 cl',
          sv: 'Apelsinjuice 20 cl'
        },
        price: { eur: 2.70, sek: 29 }
      },
      {
        id: 'cold-chocolate',
        name: {
          en: 'Cold drinking chocolate 20 cl',
          de: 'Kalte Trinkschokolade 20 cl',
          sv: 'Kall choklad 20 cl'
        },
        price: { eur: 2.70, sek: 29 },
        allergens: ['G'],
        additives: ['11']
      },
      {
        id: 'mineral-water',
        name: {
          en: 'Mineralwater (sparkling/still) 50 cl',
          de: 'Viva con Agua Mineralwasser (laut/leise) 50 cl',
          sv: 'Mineralvatten, kolsyrad/naturell 50 cl'
        },
        price: { eur: 2.70, sek: 29 }
      }
    ]
  },
  {
    id: 'beer',
    name: {
      en: 'Beer',
      de: 'Bier',
      sv: 'Öl'
    },
    items: [
      {
        id: 'flensburger-pilsner',
        name: {
          en: 'Flensburger Pilsner 33 cl',
          de: 'Flensburger Pilsner 33 cl',
          sv: 'Flensburger Pilsner 33 cl'
        },
        price: { eur: 4.70, sek: 49 },
        allergens: ['A']
      },
      {
        id: 'flensburger-gold',
        name: {
          en: 'Flensburger Gold 33 cl',
          de: 'Flensburger Gold 33 cl',
          sv: 'Flensburger Guld 33 cl'
        },
        price: { eur: 4.70, sek: 49 },
        allergens: ['A']
      },
      {
        id: 'flensburger-radler',
        name: {
          en: 'Flensburger Shandy (beer with lemonade) 33 cl',
          de: 'Flensburger Radler 33 cl',
          sv: 'Flensburger Radler 33 cl'
        },
        price: { eur: 4.70, sek: 49 },
        allergens: ['A']
      },
      {
        id: 'flensburger-non-alcoholic',
        name: {
          en: 'Flensburger non-alcoholic 33 cl',
          de: 'Flensburger Alkoholfrei 33 cl',
          sv: 'Flensburger Alkoholfri 33 cl'
        },
        price: { eur: 4.70, sek: 49 },
        allergens: ['A']
      },
      {
        id: 'seasonal-beer',
        name: {
          en: 'Seasonal beer',
          de: 'Saisonales Bier nach Angebot',
          sv: 'Säsongens öl'
        },
        price: { eur: 5.20, sek: 54 },
        allergens: ['A']
      }
    ]
  },
  {
    id: 'wine',
    name: {
      en: 'Wine and sparkling wine',
      de: 'Wein und Sekt',
      sv: 'Vin'
    },
    items: [
      {
        id: 'grauburgunder-25cl',
        name: {
          en: 'Grauburgunder | dry 25 cl',
          de: 'Grauburgunder | trocken 25 cl',
          sv: 'Grauburgunder | torr 25 cl'
        },
        description: {
          en: 'Winzergenossenschaft Achkarren, Baden, Germany',
          de: 'Winzergenossenschaft Achkarren, Baden, Deutschland',
          sv: 'Winzergenossenschaft Achkarren, Baden, Tyskland'
        },
        price: { eur: 9.70, sek: 99 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'kerner-1l',
        name: {
          en: '2021 Kerner | dry 1,0 l',
          de: '2021 Kerner | trocken 1,0 l',
          sv: '2021 Kerner | torr 1,0 l'
        },
        description: {
          en: 'Weingut Mechthild Hammel, Pfalz, Germany',
          de: 'Weingut Mechthild Hammel, Pfalz, Deutschland',
          sv: 'Weingut Mechthild Hammel, Pfalz, Tyskland'
        },
        price: { eur: 24.70, sek: 249 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'spatburgunder-25cl',
        name: {
          en: 'Spätburgunder | dry 25 cl',
          de: 'Spätburgunder | trocken 25 cl',
          sv: 'Spätburgunder | torr 25 cl'
        },
        description: {
          en: 'Winzergenossenschaft Achkarren, Baden, Germany',
          de: 'Winzergenossenschaft Achkarren, Baden, Deutschland',
          sv: 'Winzergenossenschaft Achkarren, Baden, Tyskland'
        },
        price: { eur: 9.70, sek: 99 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'portugieser-1l',
        name: {
          en: '2016 Portugieser | dry 1,0 l',
          de: '2016 Portugieser | trocken 1,0 l',
          sv: '2016 Portugieser | torr 1,0 l'
        },
        description: {
          en: 'Weingut Mechthild Hammel, Pfalz, Germany',
          de: 'Weingut Mechthild Hammel, Pfalz, Deutschland',
          sv: 'Weingut Mechthild Hammel, Pfalz, Tyskland'
        },
        price: { eur: 24.70, sek: 249 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'riesling-sekt-20cl',
        name: {
          en: 'Riesling Sekt Brut | dry 20 cl',
          de: 'Riesling Sekt Brut | trocken 20 cl',
          sv: 'Riesling Sekt Brut | torr 20 cl'
        },
        price: { eur: 12.70, sek: 129 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'riesling-sekt-75cl',
        name: {
          en: 'Riesling Sekt Brut | dry 75 cl',
          de: 'Riesling Sekt Brut | trocken 75 cl',
          sv: 'Riesling Sekt Brut | torr 75 cl'
        },
        description: {
          en: 'Weingut Mechthild Hammel, Pfalz, Germany',
          de: 'Weingut Mechthild Hammel, Pfalz, Deutschland',
          sv: 'Weingut Mechthild Hammel, Pfalz, Tyskland'
        },
        price: { eur: 38.70, sek: 399 },
        allergens: ['L'],
        tags: ['dry']
      },
      {
        id: 'riesling-secco',
        name: {
          en: 'Riesling Secco | dry 75 cl',
          de: 'Riesling Secco | trocken 75 cl',
          sv: 'Riesling Secco | torr 75 cl'
        },
        description: {
          en: 'Weingut Mechthild Hammel, Pfalz, Germany',
          de: 'Weingut Mechthild Hammel, Pfalz, Deutschland',
          sv: 'Weingut Mechthild Hammel, Pfalz, Tyskland'
        },
        price: { eur: 28.70, sek: 299 },
        allergens: ['L'],
        tags: ['dry']
      }
    ]
  },
  {
    id: 'onboard-articles',
    name: {
      en: 'Onboard articles',
      de: 'Bordartikel',
      sv: 'Artiklar ombord'
    },
    items: [
      {
        id: 'playing-cards',
        name: {
          en: 'Playing Cards',
          de: 'Spielkarten',
          sv: 'Kortlek'
        },
        price: { eur: 9.70, sek: 99 }
      },
      {
        id: 'sleeping-mask',
        name: {
          en: 'Sleeping mask',
          de: 'Schlafmaske',
          sv: 'Sovmask'
        },
        price: { eur: 4.70, sek: 49 }
      },
      {
        id: 'toothpaste',
        name: {
          en: 'Toothpaste',
          de: 'Zahnpasta',
          sv: 'Tandkräm'
        },
        price: { eur: 2.70, sek: 29 }
      },
      {
        id: 'toothbrush',
        name: {
          en: 'Toothbrush',
          de: 'Zahnbürste',
          sv: 'Tandborste'
        },
        price: { eur: 2.70, sek: 29 }
      },
      {
        id: 'ffp2-mask',
        name: {
          en: 'FFP2 mask',
          de: 'FFP2-Maske',
          sv: 'Munskydd FFP2'
        },
        price: { eur: 2.70, sek: 29 }
      },
      {
        id: 'ear-plugs',
        name: {
          en: 'Ear Plugs',
          de: 'Ohrstöpsel',
          sv: 'Öronproppar'
        },
        price: { eur: 2.70, sek: 29 }
      },
      {
        id: 'neck-cushion',
        name: {
          en: 'Inflatable neck cushion',
          de: 'Aufblasbares Nackenkissen',
          sv: 'Uppblåsbar nackkudde'
        },
        price: { eur: 14.70, sek: 149 }
      },
      {
        id: 'charging-cable',
        name: {
          en: 'iPhone & USB charging cable',
          de: 'iPhone & USB Ladekabel',
          sv: 'iPhone & USB-laddningskabel'
        },
        price: { eur: 14.70, sek: 149 }
      }
    ]
  }
];